import React from 'react'

import { displayColProps } from '../../utils'
import * as s from './Columns.module.scss'

interface IColumnsProps {
  children?: React.ReactNode | ((props: { index: number }) => React.ReactNode)
  nodeId?: string
  columns?: number
  gap?: number
}

const Columns: React.FC<IColumnsProps> = ({ children, nodeId, columns, gap = 0 }) => (
  <>
    {Array.from({ length: columns || 1 }, (_i, i) => i + 1).map((col) => (
      <div
        {...displayColProps(nodeId, col)}
        className={s.col}
        key={`col:${col}`}
        style={{
          gridArea: `${1} / ${col} / ${-1} / ${col + 1}`,
          width: `calc(100% + ${col !== columns ? gap || 0 : 0}px)`,
        }}
      >
        <div
          className={s.content}
          style={{ ...(col !== columns && { width: `calc(100% - ${gap}px)` }) }}
        >
          {typeof children === 'function' ? children({ index: col - 1 }) : children}
        </div>
      </div>
    ))}
  </>
)

export default React.memo(Columns)
